import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=4a163a6c&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=4a163a6c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a163a6c",
  null
  
)

export default component.exports